import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import MixingContext from "../../../context/materialcapture/MixingContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import MixingForm from "../../../components/materialscapture/MixingForm";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";

const MixingPage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { apiRes, setApiRes } = useContext(MixingContext);

  const backURL = '/materials-capture';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Mixing']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Mixing'} backURL={backURL} />
        <MixingForm />

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default MixingPage;